import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { SELECTED_SIGNAL } from '../../signals';
import { BigButton } from '../../big-button/bigButton.component';
import { Feature } from '../feature/feature.component';
import { getInitialStyle, defaultContext, BUTTONS_GAP, WIDTH, SPACER } from './pairingSelector.style';

export class PairingSelector extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Static: {
          Title: {
            text: {
              text: '',
            },
          },
          Feature0: {
            type: Feature,
          },
          Feature1: {
            type: Feature,
          },
          Feature2: {
            type: Feature,
          },
        },
        Buttons: {},
        Separator: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._focusedButton = 0;
  }

  get h() {
    return super.h;
  }

  set h(value) {
    super.h = value;

    this.patch({
      Static: { h: value },
      Buttons: { h: value },
      Separator: { h: value },
    });
  }

  set labels(value) {
    this.patch({
      Static: {
        Title: {
          text: {
            text: value.title,
          },
        },
      },
    });

    for (let i = 0; i < 3; i += 1) {
      const text = value.features ? value.features[i] : '';
      this.tag(`Feature${i}`).patch({
        title: text || '',
        visible: Boolean(text),
      });
    }
  }

  set buttons(value) {
    const { screenSize } = this._style;
    const w = WIDTH[screenSize] - SPACER[screenSize];
    const marginBottom = BUTTONS_GAP[this._style.screenSize];

    this.tag('Buttons').children = value.map(({ label, iconLeft, iconRight }, index) => ({
      type: BigButton,
      w,
      ref: `Button${index}`,
      label,
      pictoLeft: {
        type: 'icon',
        name: iconLeft,
      },
      pictoRight: {
        type: 'icon',
        name: iconRight,
      },
      flexItem: { marginBottom },
    }));

    if (value.length) {
      this.tag('Buttons').children[this._focusedButton].isSelected = true;
    }
  }

  get selectedButton() {
    return this.tag('Buttons').children.findIndex(button => button.isSelected);
  }

  set selectedButton(value) {
    this._focusedButton = value;

    this.tag('Buttons').children.forEach((button, index) => {
      button.isSelected = index === this._focusedButton;
    });
  }

  _getFocused() {
    return this.tag('Buttons').children[this._focusedButton];
  }

  _handleUp() {
    if (this._focusedButton > 0) {
      this._focusedButton -= 1;

      return true;
    }

    return false;
  }

  _handleDown() {
    if (this._focusedButton < this.tag('Buttons').children.length - 1) {
      this._focusedButton += 1;

      return true;
    }

    return false;
  }

  _handleLeft() {
    return true;
  }

  _handleEnter() {
    this.tag('Buttons').children.forEach((button, index) => {
      button.isSelected = index === this._focusedButton;
    });

    this.signal(SELECTED_SIGNAL, this._focusedButton);
  }
}
